export default __webpack_public_path__ + "img/upcoming_events-0fa2328bfbf47cd2f22235334f9518c4.png";